import { DatePipe } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { error } from 'highcharts';
import { ToasterService } from 'src/app/services/toaster.service';
import { VesselsService } from 'src/app/services/vessels.service';

@Component({
  selector: 'app-edit-lng',
  templateUrl: './edit-lng.component.html',
  styleUrls: ['./edit-lng.component.scss']
})
export class EditLngComponent implements OnInit {

  @Input() shipDetailsbasicinfo:any;
  @Input() getLngData:any;
  @Output() getupdateLngUsage = new EventEmitter();
  @Output() getLngStatusLoaderEvent = new EventEmitter();
  @Output() errorLngStatusLoaderEvent = new EventEmitter();
  openEditLngUsage: boolean = false
  headerName = 'Edit LNG usage'
  editLngUsageVal: string = 'editLngUsageVal_1';
  maxLength: number = 300;
  isTextError: boolean = false;
  isLngUsage: boolean = false;
  noChangeDate: any;
  showLngDiscardBanner: boolean = false;
  // getLngData: any;
  vesselActivationDate: any;
  getFYdate: any;
  disableFYdate: any;
  selectedLngUsageDate: any;
  lngUsageReason: string = '';
  lngUsageReasonError: boolean = false;
  updatePayload: { vslNumber: any; lng: any; lngEffectiveFrom: any; lngReason: any; };
  toggleLngVal: boolean = false;
  updateLngUsageData: any;
  lngUsageDate_1Val: any;
  lngUsageReasonfieldValue_1Val: string = '';
  upComingLngDate: any;
  upComingLngReason: string = '';
  upcomingLngUsageReason: string = '';
  upcomingLngUsageReasonError: boolean = false;
  selectedUpcomingLngUsageDate: any;
  openDiscardLngUsage: boolean = false;
  discardLngUsageData: any;
  discardLngSuccess: boolean = false;
  pendingLngUsageDateVal: any;
  pendingLngUsageReason: string = ''
  pendingLngUsageReasonError: boolean = false;
  openRestoreLngUsage:boolean = false;
  restoreLngUsageData: any;
  noChangeLngDate: any;
  noChangeLngReason: string = '';
  getToggleValueLng: boolean = false;
 


  constructor(private vesselService:VesselsService, 
      private toasterService: ToasterService,
      private datePipe: DatePipe) {
    }

  ngOnInit(): void {
    console.log(this.shipDetailsbasicinfo)
  }

  
  editLngUsageEvent() {
   this.editLngUsage();
  }
  editLngUsage(){
    // this.editLngUsageVal = '';
    // this.selectedLngUsageDate = null;
    // this.lngUsageReason = '';
    // this.lngUsageDate_1Val = null;
    // this.lngUsageReasonfieldValue_1Val = '';
    // this.selectedUpcomingLngUsageDate = null;
    // this.upcomingLngUsageReason = '';
    // this.pendingLngUsageDateVal = null;
    // this.pendingLngUsageReason = '';
    this.clearSidePanelData();
    this.openEditLngUsage = true;
    console.log(this.getLngData)
    this.toggleLngVal = this.getLngData?.currentLng === 1 ? true : false;
    console.log(this.toggleLngVal)
    this.getToggleValueLng = this.getLngData?.currentLng === 1 ? true : false;
    this.vesselActivationDate = this.getLngData?.vesselActivationDate;
    this.getFYdate = sessionStorage.getItem('fiscalYearStartDate');
    const date  = new Date(this.getFYdate);
    let newDate = new Date(date.setDate(date.getDate() - 1));
    this.disableFYdate = new Date(newDate.toISOString().slice(0, 10));
    console.log(this.disableFYdate)
    console.log(this.vesselActivationDate)
    this.vesselActivationDate = new Date(this.vesselActivationDate)
    if(this.getLngData?.hasPreviousChange){
      if(this.getLngData?.status.toLowerCase().trim() === 'upcomingchange'){
        this.editLngUsageVal = 'editLngUsageVal_3'
        this.showLngDiscardBanner = true;
        this.toggleLngVal = this.getLngData?.upComingLng === 1 ? true : false;
        this.upComingLngDate = this.getLngData?.upcomingEffectiveDate;
        this.upComingLngReason = this.getLngData?.upcomingReason ?? '';
        this.upcomingLngUsageReason = this.upComingLngReason;
        this.selectedUpcomingLngUsageDate = null;
      }
      if(this.getLngData?.status.toLowerCase().trim() === 'pendingcalculation'){
        this.editLngUsageVal = 'editLngUsageVal_4';
        this.pendingLngUsageDateVal = this.getLngData?.currentEffectiveDate;
        this.pendingLngUsageReason = this.getLngData?.currentReason ?? '';
      }
      if(this.getLngData?.status.toLowerCase().trim() === 'nochange'){
        this.editLngUsageVal = 'editLngUsageVal_1';
        this.noChangeLngDate = this.getLngData?.currentEffectiveDate;
        this.noChangeLngReason = this.getLngData?.currentReason;
        this.lngUsageReason = this.getLngData?.currentReason ?? '';
      }
    }else{
      this.editLngUsageVal = 'editLngUsageVal_1';
      this.noChangeLngDate = this.getLngData?.currentEffectiveDate;
      this.noChangeLngReason = this.getLngData?.currentReason;
      this.lngUsageReason = this.getLngData?.currentReason ?? '';
    }
  }

  get minSelectableDate(): Date {
    return this.vesselActivationDate > this.disableFYdate
      ? this.vesselActivationDate
      : this.disableFYdate;
  }

  get noChangeLngEffectiveDate(): Date | null {
    return this.toPickerDate(this.selectedLngUsageDate ?? this.noChangeLngDate);
  }

  get upcomingLngEffectiveDate(): Date | null {
    return this.toPickerDate(this.selectedUpcomingLngUsageDate ?? this.upComingLngDate);
  }

  get pendingLngEffectiveDate(): Date | null {
    return this.toPickerDate(this.pendingLngUsageDateVal);
  }

  get upcomingLngReasonValue(): string {
    return this.upcomingLngUsageReason || this.upComingLngReason || '';
  }

  private toPickerDate(value: unknown): Date | null {
    if (!value) {
      return null;
    }
    if (value instanceof Date) {
      return isNaN(value.getTime()) ? null : value;
    }
    const parsed = new Date(value as string);
    return isNaN(parsed.getTime()) ? null : parsed;
  }

  toggleLngUsage(event) {
    console.log(event)
    this.toggleLngVal = event?.isSwitchActive;
    if((this.getToggleValueLng && !this.toggleLngVal) || (!this.getToggleValueLng && this.toggleLngVal)){
      this.editLngUsageVal = 'editLngUsageVal_2';
    }else{
      this.editLngUsageVal = 'editLngUsageVal_1';
    }
    
    console.log("sam")
    console.log(this.getLngData)
  }
  lngUsageDate(e:any){
    this.selectedLngUsageDate = e;
    this.noChangeLngDate = null;
  }
  lngUsagefieldValue(e:any) {
    this.lngUsageReason = e;
    this.noChangeLngReason = '';
    if(this.lngUsageReason.length > 300){
      this.lngUsageReasonError = true;
    }else{
      this.lngUsageReasonError = false;
    }
  }
  upcomingLngUsageDate(e:any){
    this.selectedUpcomingLngUsageDate = e;
    this.upComingLngDate = null;
  }
  upcomingLngUsageValue(e:any){
    this.upcomingLngUsageReason = e;
    this.upComingLngReason = '';
    if(this.upcomingLngUsageReason.length > 300){
      this.upcomingLngUsageReasonError = true;
    }else{
      this.upcomingLngUsageReasonError = false;
    }
  }
  pendingLngUsageDate(e:any){
    this.pendingLngUsageDateVal = e;
  }
  pendingLngUsageValue(e:any){
    this.pendingLngUsageReason = e;
    if(this.pendingLngUsageReason.length > 300){
      this.pendingLngUsageReasonError = true;
    }else{
      this.pendingLngUsageReasonError = false;
    }
  }
  
  updateLngUsage() {
    this.getLngStatusLoaderEvent.emit();
    if(this.getLngData?.hasPreviousChange){
      if(this.getLngData?.status.toLowerCase().trim() === 'nochange'){
        this.updatePayload = {
          "vslNumber":  this.shipDetailsbasicinfo?.vslNumber,
          "lng": this.toggleLngVal,
          "lngEffectiveFrom":this.datePipe.transform(this.selectedLngUsageDate ?? this.noChangeLngDate,"yyyy-MM-dd"),
          "lngReason": this.lngUsageReason
        }
      }
      if(this.getLngData?.status.toLowerCase().trim() === 'upcomingchange'){
        this.updatePayload = {
          "vslNumber":  this.shipDetailsbasicinfo?.vslNumber,
          "lng": this.toggleLngVal,
          "lngEffectiveFrom":this.datePipe.transform(this.selectedUpcomingLngUsageDate ?? this.upComingLngDate,"yyyy-MM-dd"),
          "lngReason": this.upcomingLngUsageReason || this.upComingLngReason
        }
      }
      if(this.getLngData?.status.toLowerCase().trim() === 'pendingcalculation'){
        this.updatePayload = {
          "vslNumber":  this.shipDetailsbasicinfo?.vslNumber,
          "lng": this.toggleLngVal,
          "lngEffectiveFrom":this.datePipe.transform(this.pendingLngUsageDateVal,"yyyy-MM-dd"),
          "lngReason": this.pendingLngUsageReason
        }
      }
    }else{
      this.updatePayload = {
        "vslNumber":  this.shipDetailsbasicinfo?.vslNumber,
        "lng": this.toggleLngVal,
        "lngEffectiveFrom":this.datePipe.transform(this.selectedLngUsageDate,"yyyy-MM-dd"),
        "lngReason": this.lngUsageReason
      }
    }
    this.vesselService.updateLngDetails(this.updatePayload).subscribe({
      next:(res:any)=>{
        if(res?.data?.updateLngDetails?.success){
          this.updateLngUsageData = res?.data?.updateLngDetails?.data;
          this.discardLngSuccess = false;
          this.getupdateLngUsage.emit(this.updateLngUsageData);
          this.toasterService.openToast('Success', res?.data?.updateLngDetails?.message);
        }else{
          this.toasterService.openToast('Error', res?.data?.updateLngDetails?.message);
          this.errorLngStatusLoaderEvent.emit();
        }
      },
      error:(error:any)=>{
        this.toasterService.openToast('Error', error);
        this.errorLngStatusLoaderEvent.emit();
      }
    })
  }
 
  discardLngEvent(){
    this.openDiscardLngUsage = true;
    this.openEditLngUsage = false;
  }

  discardLngUsage() {
    this.getLngStatusLoaderEvent.emit();
    let payload = {
      "vslNumber": this.shipDetailsbasicinfo?.vslNumber,
      "isDiscarded": true
    }
    this.vesselService.discardLngDetails(payload).subscribe({
      next:(res:any)=>{
        if(res?.data?.discardLngDetails?.success){
          this.discardLngUsageData = res?.data?.discardLngDetails?.data;
          this.discardLngSuccess = true;
          this.getupdateLngUsage.emit(this.discardLngUsageData);
          this.toasterService.openToast('Success', res?.data?.discardLngDetails?.message);
        }else{
          this.toasterService.openToast('Error',  res?.data?.discardLngDetails?.message);
          this.errorLngStatusLoaderEvent.emit();
        }
      },
      error:(error:any)=>{
        this.toasterService.openToast('Error', error);
        this.errorLngStatusLoaderEvent.emit();
      }
    })
  }
  revertLngEvent(){
    this.openRestoreLngUsage = true;
    this.openEditLngUsage = false;
  }
  revertLngChanges(){
    this.getLngStatusLoaderEvent.emit();
    let payload = {
      "vslNumber": this.shipDetailsbasicinfo?.vslNumber,
      "isRestoreToPreviousAction": true
    }
    this.vesselService.revertLngDetails(payload).subscribe({
      next:(res:any)=>{
        if(res?.data?.revertLngDetails?.success){
          this.restoreLngUsageData = res?.data?.revertLngDetails?.data;
          this.getupdateLngUsage.emit(this.restoreLngUsageData);
          this.toasterService.openToast('Success', res?.data?.revertLngDetails?.message);
        }else{
          this.toasterService.openToast('Error', res?.data?.revertLngDetails?.message);
          this.errorLngStatusLoaderEvent.emit();
        }
      },
      error:(error:any)=>{
        this.toasterService.openToast('Error', error);
        this.errorLngStatusLoaderEvent.emit();
      }
    })
    
  }
  cancelDiscardLngUsage(){
    this.openDiscardLngUsage = false;
    this.editLngUsage();
  }
  closeLngSidePanel(){
    this.clearSidePanelData();
  }
  cancelLngRestore(){
    this.openRestoreLngUsage = false;
    this.editLngUsage();
  }
  clearSidePanelData(){
    this.editLngUsageVal = '';
    this.selectedLngUsageDate = null;
    this.lngUsageReason = '';
    this.lngUsageDate_1Val = null;
    this.lngUsageReasonfieldValue_1Val = '';
    this.selectedUpcomingLngUsageDate = null;
    this.upcomingLngUsageReason = '';
    this.upComingLngDate = null;
    this.upComingLngReason = '';
    this.noChangeLngDate = null;
    this.noChangeLngReason = '';
    this.pendingLngUsageDateVal = null;
    this.pendingLngUsageReason = '';
  }
  lngUsageDate_1(e:any){
    console.log(e)
    this.lngUsageDate_1Val = e;
  }
  lngUsagefieldValue_1(e:any){
    console.log(e)
    this.lngUsageReasonfieldValue_1Val = e
  }

}
